import pagesContentReducer from './pagesContentReducer';

export * from './pagesContentActions';
export default pagesContentReducer;
